import React from "react";
import PropTypes from "prop-types";
const PageIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill={color || "var(--color-easil-gray-x-dark)"} fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M4 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4zm0 2h12a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4z"
      />
      <rect width="10" height="2" x="5" y="5" rx="1" />
      <rect width="10" height="2" x="5" y="9" rx="1" />
      <rect width="4" height="2" x="5" y="13" rx="1" />
    </g>
  </svg>
);
PageIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default PageIcon;
